import {
  AccountBookOutlined,
  AlertOutlined,
  BugOutlined,
  DashboardOutlined,
  DollarCircleOutlined,
  FileOutlined,
  GroupOutlined,
  IdcardOutlined,
  ProfileOutlined,
  SettingOutlined,
  UnorderedListOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { App, ConfigProvider, Layout, Menu, theme } from "antd";
import { useState } from "react";
import { Link, Outlet } from "react-router-dom";
import { EndeavourProvider, useEndeavour } from "../hooks/useEndeavour";

const menuItems = [
  {
    key: "/",
    icon: <DashboardOutlined />,
    label: <Link to="/">Dashboard</Link>,
  },
  {
    key: "/users",
    icon: <UserOutlined />,
    label: <Link to="/users">Users</Link>,
  },
  {
    key: "/beneficiaries",
    icon: <GroupOutlined />,
    label: <Link to="/beneficiaries">Beneficiaries</Link>,
  },
  {
    key: "/transactions",
    icon: <UnorderedListOutlined />,
    label: <Link to="/transactions">Transactions</Link>,
  },
  {
    key: "/alerts",
    icon: <AlertOutlined />,
    label: <Link to="/alerts">AML Alerts</Link>,
  },
  {
    key: "/pricing",
    icon: <DollarCircleOutlined />,
    label: <Link to="/pricing">Pricing</Link>,
  },
];

const bestMatchingKey = (pathname, menuItems) => {
  let bestMatch = "";
  menuItems.forEach((item) => {
    if (pathname.startsWith(item.key) && item.key.length > bestMatch.length) {
      bestMatch = item.key;
    }
  });
  return bestMatch || "/";
};

function Container() {
  const { token } = theme.useToken();
  const endeavour = useEndeavour();
  const [customTheme, setCustomTheme] = useState({
    token: {
      // fontFamily: "Kanit",
      fontFamily: '"Binance PLEX", "IBM Plex Sans"',
    },
    components: {
      // Table: {
      //   fontFamily: "'Goldman Sans'",
      // },
      // Statistic: {
      //   fontFamily: "'Goldman Sans'",
      // },
    },
    algorithm: [theme.compactAlgorithm],
    // algorithm: [theme.darkAlgorithm, theme.compactAlgorithm],
  });

  const currentPath = window.location.pathname;
  const defaultSelectedKey = bestMatchingKey(currentPath, menuItems);

  return (
    <ConfigProvider theme={customTheme}>
      <App>
        <EndeavourProvider>
          <Layout
            style={{
              minHeight: "100vh",
            }}
          >
            <Layout.Sider
              style={{
                padding: token.padding / 2,
              }}
            >
              <Menu
                theme="dark"
                defaultSelectedKeys={[defaultSelectedKey]}
                items={[
                  {
                    key: "/",
                    icon: <DashboardOutlined />,
                    label: <Link to="/">Dashboard</Link>,
                  },
                  {
                    key: "/users",
                    icon: <UserOutlined />,
                    label: <Link to="/users">Users</Link>,
                  },
                  // {
                  //   key: "/entities",
                  //   icon: <IdcardOutlined />,
                  //   label: <Link to="/entities">Entities</Link>,
                  // },
                  // {
                  //   key: "/accounts",
                  //   icon: <AccountBookOutlined />,
                  //   label: <Link to="/accounts">Accounts</Link>,
                  // },
                  {
                    key: "/beneficiaries",
                    icon: <GroupOutlined />,
                    label: <Link to="/beneficiaries">Beneficiaries</Link>,
                  },
                  {
                    key: "/transactions",
                    icon: <UnorderedListOutlined />,
                    label: <Link to="/transactions">Transactions</Link>,
                  },
                  {
                    key: "/alerts",
                    icon: <AlertOutlined />,
                    label: <Link to="/alerts">AML Alerts</Link>,
                  },
                  // {
                  //   key: "/reports",
                  //   icon: <FileOutlined />,
                  //   label: <Link to="/reports">Reports</Link>,
                  // },
                  {
                    key: "/pricing",
                    icon: <DollarCircleOutlined />,
                    label: <Link to="/pricing">Pricing</Link>,
                  },
                  // {
                  //   key: "/profile",
                  //   icon: <ProfileOutlined />,
                  //   label: "Profile",
                  // },
                ]}
              />
            </Layout.Sider>
            <Layout>
              <Layout.Content
                style={{
                  padding: token.padding,
                }}
              >
                <Outlet />
              </Layout.Content>
              <Layout.Footer>Powered by Everpro</Layout.Footer>
            </Layout>
          </Layout>
        </EndeavourProvider>
      </App>
    </ConfigProvider>
  );
}

export default Container;
